import React from 'react';
import { Box, Typography } from '@mui/material';
import LinkedText from '../common/LinkedText';

interface DocumentationHeaderProps {
  title: string;
  description: string;
}

const DocumentationHeader: React.FC<DocumentationHeaderProps> = ({
  title,
  description
}) => {
  return (
    <Box sx={{ mb: 4, textAlign: 'left' }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#1976d2', textAlign: 'left' }}>
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 2, textAlign: 'left' }}>
        <LinkedText text={description} />
      </Typography>
    </Box>
  );
};

export default DocumentationHeader;
